import {
  getFirestore,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  where,
} from 'firebase/firestore';

// Função para buscar CIDs no Firestore com base no nome ou código
export const getCIDs = async (searchTerm, filterType, pageSize = 20) => {
  const db = getFirestore();
  const cidsRef = collection(db, 'codigosCID');

  let q;

  if (filterType === 'name') {
    const searchLower = searchTerm.toLowerCase();
    q = query(
      cidsRef,
      where('name', '>=', searchLower),
      where('name', '<=', searchLower + '\uf8ff'),
      orderBy('name'),
      limit(pageSize)
    );
  } else if (filterType === 'codigo') {
    const searchUpper = searchTerm.toUpperCase();
    q = query(
      cidsRef,
      where('codigo', '>=', searchUpper),
      where('codigo', '<=', searchUpper + '\uf8ff'),
      orderBy('codigo'),
      limit(pageSize)
    );
  }

  const querySnapshot = await getDocs(q);
  const cids = [];
  querySnapshot.forEach((doc) => {
    cids.push({ id: doc.id, ...doc.data() });
  });

  // Aqui você deve retornar o número correto de total de resultados
  return {
    items: cids,
    total: querySnapshot.size, // Ou o valor correto para total
  };
};

// Função para buscar os CIDs iniciais, sem filtro, para exibir os primeiros 20 itens
export const getInitialCIDs = async (pageSize = 20) => {
  const db = getFirestore();
  const cidsRef = collection(db, 'codigosCID');

  // Ordenação inicial pela coluna 'id'
  const q = query(cidsRef, orderBy('id'), limit(pageSize));

  const querySnapshot = await getDocs(q);
  const cids = [];
  querySnapshot.forEach((doc) => {
    cids.push({ id: doc.id, ...doc.data() });
  });

  return {
    items: cids,
    total: querySnapshot.size,
  };
};
